module.exports = __webpack_public_path__ + "static/media/service2.d8adfa4b.png";